/**
 * A non-2xx answer from one of the /api/* functions.
 *
 * Lives apart from api.ts so error-handling code (and its tests) can reason
 * about failures without importing api.ts, which initialises Firebase on load.
 */
export class ApiError extends Error {
  status: number;
  retryAfter?: number;
  constructor(message: string, status: number, opts: { retryAfter?: number } = {}) {
    super(message);
    this.status = status;
    this.retryAfter = opts.retryAfter;
  }
}
